import { render, staticRenderFns } from "./commonReportTable.vue?vue&type=template&id=773ce34c&scoped=true"
import script from "./commonReportTable.vue?vue&type=script&lang=js"
export * from "./commonReportTable.vue?vue&type=script&lang=js"
import style0 from "./commonReportTable.vue?vue&type=style&index=0&id=773ce34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ce34c",
  null
  
)

export default component.exports